import React, {useContext, useEffect} from "react";
import {renounce} from "../../Lib/auth/Api/session";
import {AppContext} from "../../Main/AppContext";
import Actions from "../../Lib/auth/AuthActions";
import {navigate} from "hookrouter";
import {AuthContext} from "../../Lib/auth/AuthContext";
import {isLoggedIn} from "../../Lib/auth/auth";

const Logout = () => {

  const authContext = useContext(AuthContext);
  const loggedIn = isLoggedIn(authContext);

  const appContext = useContext(AppContext);
  const dispatch = appContext.get('dispatch');

  // FIXME logout is sent twice for some reason

  useEffect(() => {
    if (loggedIn) {
      renounce(
          () => {
            dispatch(Actions.sessionRemove());
          },
          () => {
            // FIXME use SExp the way explained here: https://stackoverflow.com/questions/31258528/how-do-i-destroy-an-http-only-cookie-while-a-server-is-offline
            // - change SExp from HttpOnly to JS available
            // - replace SExp value with sessionId signature
            // - delete SExp here
            dispatch(Actions.sessionRemove());
          });
    }
    // TODO check if this suppress is OK
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  if (!loggedIn) navigate('/');

  return <div>&nbsp;</div>;

};

export default Logout;